import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {StorageService} from '../services/storage.service';
import {StorageKeys} from '../utils/constants/storageKeys';
import {AuthService} from '../services/auth.service';

/**
 * Guard que bloquea la ruta si el usuario ya está autenticado
 */
export const isAuthenticatedGuard: CanActivateFn = async (route, state) => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const authService = inject(AuthService);

  const data = await storage.get(StorageKeys.DATA);
  const isLoggedIn = data && data.Token;

  if (state.url === '/login') {
    if (isLoggedIn) {
      router.navigateByUrl('/tabs/repartos');
      return false;
    }
    return true;
  } else {
    if (!isLoggedIn) {
      authService.logout();
      return false;
    }
    return true;
  }
};
